import axios from 'axios'
export default() => {

 let baseURL = 'https://hope.goodhope.org.pe/adv-server';
    //let baseURL = '';
    if (process.env.NODE_ENV === 'development') {
        //baseURL = 'http://localhost:8090/estrategico/';
    }
    return axios.create({
        baseURL: baseURL,
        withCredentials: false,
        crossdomain:true,
        headers:{
            'Access-Control-Allow-Origin':'*',
            'Authorization': localStorage.getItem("hope") || ''
        }
    })
}
